import { RespondentModel } from './respondent-model';

export interface GroupModel {
  id: string;
  groupName: string;
  index: number;
  participantId: string;
  isSet: boolean;
  respondents: RespondentModel[];
  isActiveGroup: boolean;
  numberOfRespondents: number;
  numberOfRespondentsComplete?: number;
  isDirty: boolean;
  isNew: boolean;
  isValid: boolean;
  hasError: boolean;
  errorMessage: string | null;
}
